const state = {
  singer: {},
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js